var _regeneratorRuntime = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/toConsumableArray");

var _wrapNativeSuper = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _classCallCheck = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/get");

var _createClass = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/inherits");

/*!
 <lui-checkbox>
 Version: 1.3.10

 Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 All rights reserved.

 This software and other materials contain proprietary information
 controlled by HERE and are protected by applicable copyright legislation.
 Any use and utilization of this software and other materials and
 disclosure to any third parties is conditional upon having a separate
 agreement with HERE for the access, use, utilization or disclosure of this
 software. In the absence of such agreement, the use of the software is not
 allowed.
*/
(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["lui-checkbox"] = factory();else root["lui"] = root["lui"] || {}, root["lui"]["lui-checkbox"] = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "/assets/";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 181);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      1:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: true
        });
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base__ = __webpack_require__(3);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1__lui_input_base__ = __webpack_require__(6);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_2__lui_group__ = __webpack_require__(7);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_3__lui_id__ = __webpack_require__(4);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_4__lui_positioning_mixin__ = __webpack_require__(8);
        /* harmony reexport (binding) */


        __webpack_require__.d(__webpack_exports__, "LuiBase", function () {
          return __WEBPACK_IMPORTED_MODULE_0__lui_base__["a"];
        });
        /* harmony reexport (binding) */


        __webpack_require__.d(__webpack_exports__, "LuiInputBase", function () {
          return __WEBPACK_IMPORTED_MODULE_1__lui_input_base__["a"];
        });
        /* harmony reexport (module object) */


        __webpack_require__.d(__webpack_exports__, "LuiId", function () {
          return __WEBPACK_IMPORTED_MODULE_3__lui_id__;
        });
        /* harmony reexport (binding) */


        __webpack_require__.d(__webpack_exports__, "LuiGroup", function () {
          return __WEBPACK_IMPORTED_MODULE_2__lui_group__["a"];
        });
        /* harmony reexport (binding) */


        __webpack_require__.d(__webpack_exports__, "LuiPositioningMixin", function () {
          return __WEBPACK_IMPORTED_MODULE_4__lui_positioning_mixin__["a"];
        });
        /* harmony default export */


        __webpack_exports__["default"] = __WEBPACK_IMPORTED_MODULE_0__lui_base__["a"
        /* default */
        ];
        /***/
      },

      /***/
      181:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: true
        });
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_checkbox__ = __webpack_require__(182);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_lui_checkbox_global_scss__ = __webpack_require__(185);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_lui_checkbox_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lui_checkbox_global_scss__);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_2__lui_checkbox_group__ = __webpack_require__(186);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_3_lui_checkbox_group_global_scss__ = __webpack_require__(187);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_3_lui_checkbox_group_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lui_checkbox_group_global_scss__);
        /**
         * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        window.lui.registerComponent(__WEBPACK_IMPORTED_MODULE_0__lui_checkbox__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_1_lui_checkbox_global_scss___default.a);
        window.lui.registerComponent(__WEBPACK_IMPORTED_MODULE_2__lui_checkbox_group__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_3_lui_checkbox_group_global_scss___default.a);
        /***/
      },

      /***/
      182:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base__ = __webpack_require__(1);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_lui_checkbox_scss__ = __webpack_require__(183);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_lui_checkbox_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lui_checkbox_scss__);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_2_lui_checkbox_html__ = __webpack_require__(184);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_2_lui_checkbox_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lui_checkbox_html__);
        /**
         * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiCheckbox =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO) {
          _inherits(LuiCheckbox, _WEBPACK_IMPORTED_MO);

          _createClass(LuiCheckbox, null, [{
            key: "is",
            get: function get() {
              return 'lui-checkbox';
            }
          }, {
            key: "attributeToggles",
            get: function get() {
              return ['checked', 'disabled', 'indeterminate', 'name', 'required', 'tabindex', 'value'];
            }
          }, {
            key: "clickTriggers",
            get: function get() {
              return ['space'];
            }
          }, {
            key: "css",
            get: function get() {
              return __WEBPACK_IMPORTED_MODULE_1_lui_checkbox_scss___default.a;
            }
          }, {
            key: "template",
            get: function get() {
              return __WEBPACK_IMPORTED_MODULE_2_lui_checkbox_html___default.a;
            }
          }, {
            key: "hasLuiElementsInShadowDom",
            get: function get() {
              return false;
            }
          }]);

          function LuiCheckbox() {
            var _this;

            _classCallCheck(this, LuiCheckbox);

            _this = _possibleConstructorReturn(this, _getPrototypeOf(LuiCheckbox).call(this));
            _this.syncedProperties = ['checked', 'indeterminate', 'value', 'disabled'];
            return _this;
          }

          _createClass(LuiCheckbox, [{
            key: "init",
            value: function init() {
              _get(_getPrototypeOf(LuiCheckbox.prototype), "init", this).call(this);

              this._checkForLabels();

              if (!this.disabled) this.setAttribute('tabindex', 0);
            }
          }, {
            key: "onConnected",
            value: function onConnected() {
              var _this2 = this;

              _get(_getPrototypeOf(LuiCheckbox.prototype), "onConnected", this).call(this);

              this._checkForLabels();

              this._onFieldClickBound = this._onFieldClickBound || function (e) {
                return _this2._onFieldClick(e);
              };

              this._onWrapperClickBound = this._onWrapperClickBound || function (e) {
                return _this2._onWrapperClick(e);
              };

              this.wrapper.addEventListener('click', this._onWrapperClickBound);
              this.delay(function () {
                _this2._getField();

                _this2.field.addEventListener('click', _this2._onFieldClickBound);
              });
            }
          }, {
            key: "onDisconnected",
            value: function onDisconnected() {
              _get(_getPrototypeOf(LuiCheckbox.prototype), "onDisconnected", this).call(this);

              this.wrapper.removeEventListener('click', this._onWrapperClickBound);
              this.field.removeEventListener('click', this._onFieldClickBound);
            }
          }, {
            key: "_onFieldClick",
            value: function _onFieldClick(e) {
              if (this.disabled) return;
              if (this._ignoreChange) e.stopPropagation();

              this._readField();
            }
          }, {
            key: "_onWrapperClick",
            value: function _onWrapperClick() {
              if (this.hasAttribute('disabled')) return;
              if (this._ignoreChange) return;
              var event = new window.MouseEvent('click');
              this.field.dispatchEvent(event);
            }
          }, {
            key: "_checkForLabels",
            value: function _checkForLabels() {
              this.label.style.display = this.hasChildNodes() ? 'block' : 'none';
            }
          }, {
            key: "_name",
            value: function _name() {
              var e;
              return this.getAttribute('name') || (e = this.querySelector('input')) && e.name;
            }
          }, {
            key: "_readField",
            value: function _readField(field) {
              var _this3 = this;

              field = field || this.field;
              this.syncedProperties.forEach(function (property) {
                var nativeImplementation = Object.getOwnPropertyDescriptors(Object.getPrototypeOf(field))[property];
                var value = nativeImplementation ? field[property] : field.getAttribute(property);

                if (value) {
                  _this3.setAttribute(property, value === true ? '' : value);
                } else {
                  _this3.removeAttribute(property);
                }
              });
            }
          }, {
            key: "_writeField",
            value: function _writeField(field) {
              var _this4 = this;

              field = field || this.field;
              this.syncedProperties.forEach(function (property) {
                field[property] = _this4[property];
              });
              var event = new Event('change');
              this.dispatchEvent(event);
            }
          }, {
            key: "disabledChanged",
            value: function disabledChanged() {
              _get(_getPrototypeOf(LuiCheckbox.prototype), "disabledChanged", this).call(this);

              var disabled = this.disabled;
              this.toggleCssClass('lui-disabled', disabled);
              this.wrapper.classList[disabled ? 'remove' : 'add']('lui-interactive');
            }
          }, {
            key: "checkedChanged",
            value: function checkedChanged() {
              this._writeField();
            }
          }, {
            key: "indeterminateChanged",
            value: function indeterminateChanged() {
              this._writeField();
            }
          }, {
            key: "valueChanged",
            value: function valueChanged() {
              this._writeField();
            }
          }, {
            key: "_getField",
            value: function _getField() {
              this._field = this.querySelector('input');
              this._ignoreChange = true;
              var temporaryField = this.shadowRoot.querySelector('input');

              if (this._field) {
                if (temporaryField) temporaryField.parentNode.removeChild(temporaryField);

                if (this._field.type !== 'checkbox') {
                  console.error("<input type=\"".concat(this._field.type, "\"> is not supported."));
                }

                if (!this.fieldListenerInitialized) this._addPropertyListenerToField(this._field);
                this.fieldListenerInitialized = true;

                this._readField(this._field);

                this._writeField(this._field);
              } else if (temporaryField) {
                this._field = temporaryField;

                this._writeField(this._field);
              } else {
                var field = this._createField();

                this._writeField(field);

                this._field = field;
              }

              this._ignoreChange = false;
              return this._field;
            }
          }, {
            key: "_createField",
            value: function _createField() {
              var element = document.createElement('input');
              element.type = 'checkbox';
              this.label.appendChild(element);
              return element;
            }
          }, {
            key: "_addPropertyListenerToField",
            value: function _addPropertyListenerToField(field) {
              var _this5 = this;

              this.syncedProperties.forEach(function (property) {
                var nativeImplementation = Object.getOwnPropertyDescriptors(Object.getPrototypeOf(field))[property];
                if (!nativeImplementation) return;
                Object.defineProperty(field, property, {
                  set: function set(value) {
                    nativeImplementation.set.call(field, value);
                    if (_this5._ignoreChange) return;
                    _this5._ignoreChange = true;

                    _this5._readField();

                    _this5._ignoreChange = false;
                  },
                  get: nativeImplementation.get
                });
              });
            }
          }, {
            key: "label",
            get: function get() {
              return this._label || (this._label = this.shadowRoot.querySelector('.lui-checkbox__label'));
            }
          }, {
            key: "indicator",
            get: function get() {
              return this._indicator || (this._indicator = this.shadowRoot.querySelector('.lui-checkbox__indicator'));
            }
          }, {
            key: "wrapper",
            get: function get() {
              return this._wrapper || (this._wrapper = this.shadowRoot.querySelector('.lui-checkbox__wrapper'));
            }
          }, {
            key: "value",
            get: function get() {
              return this._field ? this._field.value : this.getAttribute('value');
            },
            set: function set(newValue) {
              this.setAttribute('value', newValue);
              this.valueChanged('', newValue);
            }
          }, {
            key: "checked",
            get: function get() {
              return this._field ? this._field.checked : this.hasAttribute('checked');
            },
            set: function set(newValue) {
              if (this.checked === newValue) return;

              if (newValue) {
                this.setAttribute('checked', '');
              } else {
                this.removeAttribute('checked');
              }
            }
          }, {
            key: "indeterminate",
            get: function get() {
              return this._field ? this._field.indeterminate : this.hasAttribute('indeterminate');
            },
            set: function set(newValue) {
              if (this.indeterminate === newValue) return;

              if (newValue) {
                this.setAttribute('indeterminate', '');
              } else {
                this.removeAttribute('indeterminate');
              }
            }
          }]);

          return LuiCheckbox;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_base__["LuiInputBase"]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiCheckbox;
        /***/
      },

      /***/
      183:
      /***/
      function _(module, exports) {
        module.exports = ":host{display:inline-block;outline:none}.lui-checkbox__wrapper{-ms-flex-align:center;align-items:center;color:var(--lui-text-color);display:-ms-inline-flexbox;display:inline-flex;font-family:var(--lui-font-family);font-size:var(--lui-font-size);font-weight:var(--lui--normal);height:var(--lui-control-height);line-height:var(--lui-line-height);padding:var(--lui-padding-y) calc(var(--lui-padding-y) + 3px);position:relative;transition:var(--lui-transitions-default);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.lui-checkbox__indicator{background:var(--lui-field-background-color);border:var(--lui-border-width) var(--lui-field-border-color) solid;border-radius:var(--lui-border-radius);color:var(--lui-field-text-color);display:block;-ms-flex-negative:0;flex-shrink:0;height:var(--lui-line-height);transition:var(--lui-transitions-default);width:var(--lui-line-height);box-shadow:transparent 0 0 0 calc(3 * var(--lui-focus-ring-width))}:host(:focus) .lui-checkbox__indicator{box-shadow:var(--lui-focus-ring-color) 0 0 0 var(--lui-focus-ring-width)}.lui-checkbox__checked,.lui-checkbox__indeterminate{display:block;height:var(--lui-line-height);opacity:0;pointer-events:none;position:absolute;transform:scale(0);transition:transform .1s cubic-bezier(.4,0,.7,2.2);width:var(--lui-line-height)}.lui-checkbox__checked .lui-checkbox__icon,.lui-checkbox__indeterminate .lui-checkbox__icon{fill:var(--lui-accent-text-color)}:host([checked]) .lui-checkbox__indicator,:host([indeterminate]) .lui-checkbox__indicator{background:var(--lui-accent-color)}:host([checked][disabled]) .lui-checkbox__indicator,:host([indeterminate][disabled]) .lui-checkbox__indicator{background:var(--lui-accent-color);border:var(--lui-border-width) rgba(0,0,0,.05) solid;filter:saturate(.3)}:host([checked]:not([indeterminate])) .lui-checkbox__checked,:host([indeterminate]) .lui-checkbox__indeterminate{opacity:1;transform:scale(1)}input{display:none}.lui-checkbox__label:not(:empty){display:none;margin-left:.6em}";
        /***/
      },

      /***/
      184:
      /***/
      function _(module, exports) {
        module.exports = "<div class=\"lui-checkbox__wrapper lui-interactive\">\n  <div class=\"lui-checkbox__indicator\"></div>\n  <svg viewBox=\"0 0 20 20\" class=\"lui-checkbox__indeterminate\">\n    <rect class=\"lui-checkbox__icon\" x=\"5\" y=\"8.75\" width=\"10\" height=\"2.5\" rx=\"1\"></rect>\n  </svg>\n  <svg viewBox=\"0 0 20 20\" class=\"lui-checkbox__checked\">\n    <path class=\"lui-checkbox__icon\" d=\"M14.828,7.937 L10.152,12.611 L9.275,13.49 C9.157,13.605 8.997,13.67 8.836,13.67 C8.674,13.67 8.512,13.605 8.395,13.49 L7.517,12.611 L5.182,10.275 C5.066,10.158 5,9.998 5,9.836 C5,9.674 5.066,9.514 5.182,9.396 L6.06,8.52 C6.175,8.402 6.338,8.338 6.497,8.338 C6.66,8.338 6.824,8.402 6.937,8.52 L8.836,10.424 L13.073,6.182 C13.187,6.066 13.347,6 13.51,6 C13.671,6 13.834,6.066 13.949,6.182 L14.828,7.061 C14.943,7.176 15.007,7.338 15.007,7.498 C15.007,7.66 14.943,7.82 14.828,7.937\"></path>\n  </svg>\n  <label class=\"lui-checkbox__label\">\n    <slot></slot>\n  </label>\n</div>\n";
        /***/
      },

      /***/
      185:
      /***/
      function _(module, exports) {
        module.exports = "lui-checkbox input{display:none}";
        /***/
      },

      /***/
      186:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base__ = __webpack_require__(1);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiCheckboxGroup =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO2) {
          _inherits(LuiCheckboxGroup, _WEBPACK_IMPORTED_MO2);

          function LuiCheckboxGroup() {
            _classCallCheck(this, LuiCheckboxGroup);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiCheckboxGroup).apply(this, arguments));
          }

          _createClass(LuiCheckboxGroup, null, [{
            key: "is",
            get: function get() {
              return 'lui-checkbox-group';
            }
          }]);

          return LuiCheckboxGroup;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_base__["LuiGroup"]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiCheckboxGroup;
        /***/
      },

      /***/
      187:
      /***/
      function _(module, exports) {
        module.exports = "lui-checkbox-group{display:-ms-grid;display:grid}lui-checkbox-group[columns=\"2\"]{-ms-grid-columns:1fr 1fr;grid-template-columns:1fr 1fr}lui-checkbox-group[columns=\"3\"]{-ms-grid-columns:1fr 1fr 1fr;grid-template-columns:1fr 1fr 1fr}lui-checkbox-group[columns=\"4\"]{-ms-grid-columns:1fr 1fr 1fr 1fr;grid-template-columns:1fr 1fr 1fr 1fr}lui-checkbox-group[columns=\"5\"]{-ms-grid-columns:1fr 1fr 1fr 1fr 1fr;grid-template-columns:1fr 1fr 1fr 1fr 1fr}lui-checkbox-group[columns=\"6\"]{-ms-grid-columns:1fr 1fr 1fr 1fr 1fr 1fr;grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr}";
        /***/
      },

      /***/
      2:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        var LuiElement =
        /*#__PURE__*/
        function (_HTMLElement) {
          _inherits(LuiElement, _HTMLElement);

          function LuiElement() {
            _classCallCheck(this, LuiElement);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiElement).apply(this, arguments));
          }

          _createClass(LuiElement, null, [{
            key: "cssClass",
            value: function cssClass() {
              return this.dasherize(this.name);
            }
          }, {
            key: "modifierCssClass",
            value: function modifierCssClass(name) {
              return this.cssClass() + '-' + name;
            }
          }, {
            key: "dasherize",
            value: function dasherize(name) {
              return name.replace(/[A-Z]+/g, function (c, p) {
                return (p > 0 ? '-' : '') + c.toLowerCase();
              });
            }
          }, {
            key: "is",
            get: function get() {
              return '';
            }
          }]);

          return LuiElement;
        }(_wrapNativeSuper(HTMLElement));
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiElement;
        /***/
      },

      /***/
      3:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_element__ = __webpack_require__(2);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_reset_local_scss__ = __webpack_require__(5);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_reset_local_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reset_local_scss__);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_2__lui_id__ = __webpack_require__(4);
        /**
         * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiBase =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO3) {
          _inherits(LuiBase, _WEBPACK_IMPORTED_MO3);

          _createClass(LuiBase, null, [{
            key: "_addCssClassToggles",
            value: function _addCssClassToggles(list) {
              var _this7 = this;

              this._cssClassToggles = {};

              if (!list) {
                return [];
              }

              if (Array.isArray(list)) {
                list.forEach(function (a) {
                  return _this7._addCssClassToggle(a);
                });
                return list;
              }

              Object.keys(list).forEach(function (a) {
                return _this7._addCssClassToggle(a, list[a]);
              });
              return Object.keys(list);
            }
          }, {
            key: "_addCssClassToggle",
            value: function _addCssClassToggle(attribute, cssClass) {
              cssClass = cssClass || this.modifierCssClass(attribute);
              this._cssClassToggles[attribute] = cssClass;
            }
          }, {
            key: "cssClassToggles",
            get: function get() {
              return [];
            }
          }, {
            key: "attributeToggles",
            get: function get() {
              return [];
            }
          }, {
            key: "css",
            get: function get() {
              return '';
            }
          }, {
            key: "template",
            get: function get() {
              return '';
            }
          }, {
            key: "hasLuiElementsInShadowDom",
            get: function get() {
              return true;
            }
          }, {
            key: "observedAttributes",
            get: function get() {
              var attributes = Object.getOwnPropertyNames(this.prototype).map(function (attribute) {
                if (attribute.match(/Changed$/)) {
                  return attribute.replace(/Changed$/, '');
                }
              }).filter(function (i) {
                return i !== undefined;
              });
              return [].concat(_toConsumableArray(attributes), _toConsumableArray(this._addCssClassToggles(this.cssClassToggles)), _toConsumableArray(this.attributeToggles));
            }
          }]);

          function LuiBase() {
            var _this6;

            _classCallCheck(this, LuiBase);

            _this6 = _possibleConstructorReturn(this, _getPrototypeOf(LuiBase).call(this));
            _this6._uid = Object(__WEBPACK_IMPORTED_MODULE_2__lui_id__["generateId"])(_this6.constructor.name);
            _this6._isFirstTimeConnected = true;
            _this6.shadowRoot = _this6.attachShadow({
              mode: 'open'
            });

            _this6.render();

            _this6._addBooleanSupport();

            return _this6;
          }

          _createClass(LuiBase, [{
            key: "render",
            value: function render() {
              var css = __WEBPACK_IMPORTED_MODULE_1_reset_local_scss___default.a + this.constructor.css;

              if (window.lui.applyCssPolyfill) {
                css = window.lui.applyCssPolyfill(css, this);
              }

              this.shadowRoot.innerHTML += "<style>".concat(css, "</style>").concat(this.constructor.template);
            }
          }, {
            key: "connectedCallback",
            value: function connectedCallback() {
              var _this8 = this;

              if (this._isFirstTimeConnected) {
                this.seedElement = this._getSeed();
                this.withoutTransition(function () {
                  _this8.init();

                  _this8._initialized = true;
                });
              }

              this._isFirstTimeConnected = false;

              if (this.constructor.hasLuiElementsInShadowDom) {
                var styles = window.getComputedStyle(this);
                var themeCascade = styles.getPropertyValue('--lui-theme-cascade');

                if (themeCascade) {
                  var themeCss = window.lui.themeCss[themeCascade];
                  var style = document.createElement('style');
                  style.textContent = themeCss;
                  this.shadowRoot.insertBefore(style, this.shadowRoot.firstChild);
                }
              }

              this.onConnected(); // #ifndef DEBUG

              if (!this.seedElement) {
                throw new Error('The attribute seedelement was not set! Please set a seedelement for your class ' + this.constructor.name);
              } // #endif

            }
          }, {
            key: "onConnected",
            value: function onConnected() {}
          }, {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
              this.onDisconnected();
            }
          }, {
            key: "onDisconnected",
            value: function onDisconnected() {}
          }, {
            key: "init",
            value: function init() {}
          }, {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(attrName, oldVal, newVal) {
              this._applyCssClassToggle(attrName, oldVal);

              if (this.constructor.attributeToggles.includes(attrName)) {
                this[newVal === null ? '_removeSeedAttribute' : '_addSeedAttribute'](attrName, newVal);
              }

              this._callAttributeChangedCallback(attrName, oldVal, newVal);
            }
          }, {
            key: "_applyCssClassToggle",
            value: function _applyCssClassToggle(attrName, oldVal) {
              var _this9 = this;

              var cssClass = this.constructor._cssClassToggles[attrName];

              if (cssClass) {
                this.withoutTransition(function () {
                  _this9.toggleCssClass(cssClass, oldVal === null);
                });
              }
            }
          }, {
            key: "withoutTransition",
            value: function withoutTransition(withoutTransitionCallback) {
              var _this10 = this;

              return new Promise(function (resolve, reject) {
                requestAnimationFrame(function () {
                  _this10.classList.add('lui-without-transition');

                  withoutTransitionCallback();
                  requestAnimationFrame(function () {
                    if (_this10._initialized) {
                      _this10.classList.remove('lui-without-transition');
                    }

                    resolve();
                  });
                });
              });
            }
          }, {
            key: "_callAttributeChangedCallback",
            value: function _callAttributeChangedCallback(attrName, oldVal, newVal) {
              var func = this[attrName + 'Changed'];

              if (func) {
                func.call(this, oldVal, newVal);
              }
            }
          }, {
            key: "toggleCssClass",
            value: function toggleCssClass(cssClass, state) {
              this.classList[state ? 'add' : 'remove'](cssClass);
            }
          }, {
            key: "_getSeed",
            value: function _getSeed() {
              var seed = this.shadowRoot.querySelector('[seedelement]');
              return seed || this;
            }
          }, {
            key: "toggleModifier",
            value: function toggleModifier(name, state) {
              this.toggleCssClass(this.constructor.modifierCssClass(name), state);
            } // delayed call to prevent early execution

          }, {
            key: "delay",
            value: function delay(f) {
              var _this11 = this;

              setTimeout(function () {
                return f.call(_this11);
              }, 1);
            }
          }, {
            key: "_addSeedAttribute",
            value: function _addSeedAttribute(name, value) {
              if (this.seedElement === this) return;

              if (this.seedElement) {
                this.seedElement.setAttribute(name, value || '');
              } else {
                this._seedAttributes = this._seedAttributes || [];
                this._seedAttributes[name] = value || '';
              }
            }
          }, {
            key: "_removeSeedAttribute",
            value: function _removeSeedAttribute(name) {
              if (this.seedElement) {
                this.seedElement.removeAttribute(name);
              } else {
                this._seedAttributes = this._seedAttributes || [];

                var index = this._seedAttributes.indexOf(name);

                if (index > -1) this._seedAttributes.splice(index, 1);
              }
            }
          }, {
            key: "_addBooleanSupport",
            value: function _addBooleanSupport() {
              var _this12 = this;

              this.hasAttributeWithoutBooleanSupport = this.hasAttribute;

              this.hasAttribute = function (name) {
                return _this12.hasAttributeWithoutBooleanSupport(name) && _this12.getAttribute(name) !== 'false';
              };
            }
          }, {
            key: "shadowRoot",
            get: function get() {
              return this._shadowRoot;
            },
            set: function set(value) {
              this._shadowRoot = value;
            }
          }, {
            key: "seedElement",
            get: function get() {
              return this._seedElement;
            },
            set: function set(value) {
              var _this13 = this;

              var className = LuiBase.dasherize(this.constructor.is) + '__seed';
              if (this._seedElement) this._seedElement.classList.remove(className);
              this._seedElement = value;
              this.seedElement.classList.add(className);

              if (this._seedAttributes) {
                Object.keys(this._seedAttributes).forEach(function (key) {
                  _this13.seedElement.setAttribute(key, _this13._seedAttributes[key]);
                });
              }
            }
          }, {
            key: "initialized",
            get: function get() {
              return this._initialized;
            }
          }, {
            key: "uid",
            get: function get() {
              return this._uid;
            }
          }]);

          return LuiBase;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_element__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiBase;
        /***/
      },

      /***/
      4:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        var _marked =
        /*#__PURE__*/
        _regeneratorRuntime.mark(_autoIncrementGenerator);

        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: true
        });
        /* harmony export (immutable) */

        __webpack_exports__["generateId"] = generateId;
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */

        function _autoIncrementGenerator() {
          var id;
          return _regeneratorRuntime.wrap(function _autoIncrementGenerator$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  id = 0;

                case 1:
                  if (!true) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 4;
                  return id;

                case 4:
                  id += 1;
                  _context.next = 1;
                  break;

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _marked, this);
        }

        var _autoIncrementGeneratorInstance = _autoIncrementGenerator();

        function generateId() {
          var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

          var id = _autoIncrementGeneratorInstance.next().value;

          return "".concat(prefix).concat(prefix ? '_' : '').concat(id);
        }
        /***/

      },

      /***/
      5:
      /***/
      function _(module, exports) {
        module.exports = "html{box-sizing:border-box}*{background:transparent;border:0;font-family:inherit;font-size:inherit;list-style:none;margin:0;padding:0;text-align:inherit}*,:after,:before{box-sizing:inherit}audio,embed,iframe,img,object,video{height:auto;max-width:100%}";
        /***/
      },

      /***/
      6:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base__ = __webpack_require__(3);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiInputBase =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO4) {
          _inherits(LuiInputBase, _WEBPACK_IMPORTED_MO4);

          function LuiInputBase() {
            _classCallCheck(this, LuiInputBase);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiInputBase).apply(this, arguments));
          }

          _createClass(LuiInputBase, [{
            key: "init",
            value: function init() {
              this._makeFocusable();

              _get(_getPrototypeOf(LuiInputBase.prototype), "init", this).call(this);
            }
          }, {
            key: "onConnected",
            value: function onConnected() {
              if (this.disabled) return;
              this._onFocusBound = this._onFocusBound || this._onFocus.bind(this);
              this._onBlurBound = this._onBlurBound || this._onBlur.bind(this);
              this.eventListenerElement.addEventListener('focus', this._onFocusBound);
              this.eventListenerElement.addEventListener('blur', this._onBlurBound);
            }
          }, {
            key: "onDisconnected",
            value: function onDisconnected() {
              if (this.disabled) return;
              this.removeEventListener('focus', this._onFocus);
              this.removeEventListener('blur', this._onBlur);
            }
          }, {
            key: "disabledChanged",
            value: function disabledChanged() {
              if (this.disabled) {
                this.removeAttribute('tabindex');
                this.eventListenerElement.removeEventListener('focus', this._onFocusBound);
                this.eventListenerElement.removeEventListener('blur', this._onBlurBound);
              } else {
                this._makeFocusable();

                this.eventListenerElement.addEventListener('focus', this._onFocusBound);
                this.eventListenerElement.addEventListener('blur', this._onBlurBound);
              }
            }
          }, {
            key: "_makeFocusable",
            value: function _makeFocusable() {
              if (!this.disabled && (this.field === this || window.getComputedStyle(this.field).display === 'none')) {
                this.setAttribute('tabindex', 0);
              }
            }
          }, {
            key: "_onFocus",
            value: function _onFocus() {
              if (this.constructor.hasClickTriggers) {
                this._onKeyDownBound = this._onKeyDownBound || this._onKeyDown.bind(this);
                this.eventListenerElement.addEventListener('keydown', this._onKeyDownBound);
              }
            }
          }, {
            key: "_onBlur",
            value: function _onBlur() {
              if (this.constructor.hasClickTriggers && this._onKeyDownBound) {
                this.eventListenerElement.addEventListener('keydown', this._onKeyDownBound);
              }
            }
          }, {
            key: "_onKeyDown",
            value: function _onKeyDown(event) {
              var clickTriggers = this.constructor.clickTriggers; // ' ' for modern browsers, 'space bar' for IE:

              var spaceKey = ' |space bar';
              var regexp = new RegExp(clickTriggers.join('|').replace('space', spaceKey), 'i');

              if (event.key.match(regexp)) {
                event.preventDefault();
                event.stopPropagation();
                this._ignoreChange = true;

                if (this.constructor.clickEvent === 'click') {
                  // .click() is more reliable than creating a MouseEvent/Event, for example for Rails UJS
                  this.field.click();
                } else {
                  var clickEvent = new window.MouseEvent(this.constructor.clickEvent, {
                    bubbles: true
                  });
                  this.field.dispatchEvent(clickEvent);
                }

                this._ignoreChange = false;
              }
            }
          }, {
            key: "_getField",
            value: function _getField() {
              return this;
            }
          }, {
            key: "_getEventListenerElement",
            value: function _getEventListenerElement() {
              var element = this.field;

              if (element.querySelector(this.constructor.is) !== this) {
                element = this;
              }

              return element;
            }
          }, {
            key: "field",
            get: function get() {
              this._field = this._field || this._getField();
              return this._field;
            }
          }, {
            key: "eventListenerElement",
            get: function get() {
              this._eventListenerElement = this._eventListenerElement || this._getEventListenerElement();
              return this._eventListenerElement;
            }
          }, {
            key: "disabled",
            get: function get() {
              return this.field !== this && this.field.disabled || this.hasAttribute('disabled');
            },
            set: function set(value) {
              if (value) {
                this.setAttribute('disabled', '');
              } else {
                this.removeAttribute('disabled');
              }
            }
          }], [{
            key: "clickTriggers",
            get: function get() {
              return [];
            }
          }, {
            key: "clickEvent",
            get: function get() {
              return 'click';
            }
          }, {
            key: "hasClickTriggers",
            get: function get() {
              return this.clickTriggers.length !== 0;
            }
          }]);

          return LuiInputBase;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_base__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiInputBase;
        /***/
      },

      /***/
      7:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_element__ = __webpack_require__(2);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiGroup =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO5) {
          _inherits(LuiGroup, _WEBPACK_IMPORTED_MO5);

          function LuiGroup() {
            _classCallCheck(this, LuiGroup);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiGroup).apply(this, arguments));
          }

          return LuiGroup;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_element__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiGroup;
        /***/
      },

      /***/
      8:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        var LuiPositioningMixin = function LuiPositioningMixin(Superclass) {
          return (
            /*#__PURE__*/
            function (_Superclass) {
              _inherits(_class, _Superclass);

              function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
              }

              _createClass(_class, [{
                key: "getRelativePosition",
                value: function getRelativePosition(element) {
                  var componentPosition = this.getBoundingClientRect();
                  var elementPosition = element.getBoundingClientRect();
                  var componentStyle = window.getComputedStyle(this);
                  var componentPaddingTop = parseInt(componentStyle.paddingTop, 10) || 0;
                  var componentPaddingLeft = parseInt(componentStyle.paddingLeft, 10) || 0;
                  return {
                    top: elementPosition.top - componentPosition.top - componentPaddingTop,
                    left: elementPosition.left - componentPosition.left - componentPaddingLeft
                  };
                }
              }]);

              return _class;
            }(Superclass)
          );
        };
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiPositioningMixin;
        /***/
      }
      /******/

    })
  );
});